import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

export interface ProductCatalogChip {
  countryProductCatalog: boolean;
  visible: boolean;
  labelProvider: labelProviderInterface;
}

export const ProductCatalogChip: FunctionalComponent<ProductCatalogChip> = (
  props
) => {
    const { countryProductCatalog, visible, labelProvider } = props;
    return visible ? (
      <span class="readonly-chip">
        <se-tooltip position="top" color="alternative">
          <svs-chip
            read-only="true"
            name={
              countryProductCatalog
                ? labelProvider('product.catalog.filter.country', 'Country')
                : labelProvider('product.catalog.filter.global', 'Global')
            }
            slot="trigger"
          ></svs-chip>
          <se-tooltip-content class="product-catalog-chip-tooltip-content">
            {countryProductCatalog
              ? labelProvider('product.catalog.filter.country', 'Country')
              : labelProvider('product.catalog.filter.global', 'Global')}
          </se-tooltip-content>
        </se-tooltip>
      </span>
    ) : (
      ''
    );
};
